<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import store from "@/store";

import { MobileRegisterTheme, DesktopRegisterTheme } from ".";

import { tabList } from "@/common/settings/register";

const { t } = useI18n();
const route = useRoute();

defineProps<{
  tabActive: string;
}>();

const accountId = computed(() => route.params.id as string);

const menuList = computed(() =>
  tabList.reduce((acc, item) => {
    const modules = store.getters.modules;

    if (modules.find((mod) => mod.code === `${item.key.toUpperCase()}_NOT`)) {
      return acc;
    } else {
      acc.push({
        ...item,
        label: t(item.label),
        url: `/${accountId.value}${item.url}`,
      });
    }

    return acc;
  }, []),
);
</script>

<template>
  <template v-if="!$store.getters.mobile">
    <desktop-register-theme :menu-list="menuList" :tab-active="tabActive">
      <template #title>
        <slot name="title"></slot>
      </template>
      <template #content>
        <slot name="content"></slot>
      </template>
    </desktop-register-theme>
  </template>

  <template v-else>
    <mobile-register-theme
      :menu-list="menuList"
      :account-id="accountId"
      :tab-active="tabActive"
    >
      <template #title>
        <slot name="title"></slot>
      </template>
      <template #content>
        <slot name="content"></slot>
      </template>
    </mobile-register-theme>
  </template>
</template>

<style lang="scss" scoped>
.screen {
  display: grid;
  width: 100%;
  height: 100dvh;
  grid-template-columns: auto 1fr;

  .pages {
    display: flex;
    flex-direction: column;

    main {
      display: flex;
      flex-direction: column;
      padding-block-start: 1.57rem;
      padding-block-end: 1.57rem;
      padding-inline: 1.57rem;
      height: calc(100dvh - 80px - 1.57rem);
      overflow-y: auto;
    }
  }
}
</style>
